import { render, staticRenderFns } from "./FPlaceholder.vue?vue&type=template&id=adfe61bc&"
import script from "./FPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./FPlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports